/**
 * @param { Promise } promise
 * @param { Object } improved - If you need to enhance the error.
 * @return { Promise }
 * @example const [err, res] = await promiser(ApiRequest.get("/foo/"));
 */
const promiser = (promise, improved) => promise
	.then((data) => [null, data])
	.catch((err) => {
		if (improved) {
			Object.assign(err, improved);
		}

		return [err]; // which is same as [err, undefined];
	});

export default promiser;
